<template>
  <v-container>
    <!--    Heading-->
    <v-row>
      <v-col md="4" sm="12" class="primary--text">
        <h4 class="title mb-2">Timeless {{ $route.name }}</h4>
        <p style="font-size: .7rem"></p>
      </v-col>
      <v-col md="4" sm="12"></v-col>
    </v-row>

    <!-- Search -->
    <v-row class="justify-end">
      <v-col md="4" sm="12">
        <v-text-field
          rounded
          filled
          flat
          class="search"
          v-model="search"
          placeholder="Search"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Actions   -->
    <v-row
      class="flex-column justify-start align-start flex-md-row justify-md-between align-md-center mb-6"
    >
      <v-col cols="6">
        <v-form>
          <v-row no-gutters>
            <v-col>
              <AddVehicle :vehicle="deleteVehicle" />
              <UpdateVehicle :vehicle="deleteVehicle" />
            </v-col>
            <v-col>
              <WarningModal
                :handleConfirm="handleConfirm"
                v-if="$store.getters['Dashboard/showWarningModal']"
              />

              <SuccessModal
                v-if="$store.getters['Dashboard/showSuccessModal']"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-col>

      <v-col md-4 class="d-flex justify-start justify-md-end align-center">
        <download-csv
          class="btn btn-default"
          :data="vehicles"
          name="vehicles.csv"
        >
          <v-icon
            medium
            color="dark-gray  darken-2"
            style="padding: 10px; background: lightgray; border-radius:50%; cursor: pointer"
          >
            mdi-export
          </v-icon>
          <span class="ml-2">Download CSV</span>
        </download-csv>
      </v-col>
    </v-row>

    <!--    Page-->
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          class="v-table"
          :items="filteredVehicles"
          show-select
          dense
        >
          <template v-slot:item.image="{ item }">
            <v-avatar class="ma-2">
              <img :src="item.image" :alt="item.reg_no" />
            </v-avatar>
          </template>
          <template v-slot:item.insurance_cert_doc="{ item }">
            <a
              class="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
              :href="item.insurance_cert_doc"
            >
              <v-icon
                color="primary"
                small
                class="mr-2"
                v-if="item.insurance_cert_doc"
              >
                mdi-export
              </v-icon>
              <p v-else>N/A</p>
            </a>
          </template>
          <template v-slot:item.cert="{ item }">
            <a class="text-decoration-none" :href="item.cert">
              <v-icon color="primary" small class="mr-2">
                mdi-export
              </v-icon>
            </a>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on">
                  mdi-dots-vertical
                </v-icon>
              </template>

              <v-list>
                <v-list-item style="cursor: pointer" @click="open(item)">
                  <v-list-item-title class="d-flex flex-row align-center">
                    <v-icon style="font-size: 1.2rem" color="secondary"
                      >mdi-eye</v-icon
                    >
                    <span class="d-block">View</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  style="cursor: pointer"
                  @click="handleUpdate(item)"
                >
                  <v-list-item-title class="d-flex flex-row align-center">
                    <v-icon style="font-size: 1.2rem" color="primary"
                      >mdi-pencil</v-icon
                    >
                    <span class="d-block">Edit</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  style="cursor: pointer"
                  @click="handleDelete(item)"
                >
                  <v-list-item-title class="d-flex flex-row align-center">
                    <v-icon style="font-size: 1.2rem; color: tomato"
                      >mdi-trash-can</v-icon
                    >
                    <span class="d-block">Delete</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddVehicle from "@/components/Dashboard/Vehicles/AddVehicle";
import UpdateVehicle from "@/components/Dashboard/Vehicles/UpdateVehicle";
import WarningModal from "@/components/Dashboard/Modals/WarningModal";
import SuccessModal from "@/components/Dashboard/Modals/SuccessModal";
export default {
  name: "Vehicles",
  components: {
    WarningModal,
    SuccessModal,
    UpdateVehicle,
    AddVehicle
  },
  data: () => ({
    bio: true,
    checkbox: "",
    dialog: false,
    dialogTwo: false,
    dialogDelete: false,
    modalLoading: false,
    tab: null,
    snackbar: false,
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    formData: {
      vehicle_type_id: "",
      reg_no: "",
      insurance_expiry_date: "",
      insurance_cert_no: "",
      insurance_company: "",
      log_book_no: "",
      owner_id: ""
    },
    headers: [
      // { text: "", align: "start", value: "image" },
      { text: "Registration No", value: "reg_no" },
      { text: "Insurance Certificate No.", value: "insurance_cert_no" },
      { text: "Insurance Certificate", value: "insurance_cert_doc" },
      { text: "Insurance Company", value: "insurance_company" },

      { text: "Insurance Expiry Date", value: "insurance_expiry_date" },
      { text: "Log Book No", value: "log_book_no" },
      // { text: "Policy Certificate", value: "cert" },
      { text: "Owner", value: "owner_id" },
      { text: "Actions", value: "actions", sortable: false }
    ],

    deleteVehicle: {},

    // Search
    search: ""
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    vehicles() {
      return this.$store.getters["Dashboard/vehicles"];
    },

    filteredVehicles() {
      return this.vehicles.filter(vehicle => {
        return vehicle.reg_no.toLowerCase().match(this.search.toLowerCase());
      });
    }
  },

  watch: {
    vehicles(v) {
      console.log(v)
    }
  },

  created() {
    this.$store.dispatch("Dashboard/fetchVehicles");
    console.log(this.vehicles)
  },

  mounted() {
    Event.$on("modalLoading", value => {
      this.modalLoading = value;
    });
  },

  methods: {
    open: function(vehicle) {
      this.$router.push({ name: "Vehicle", params: { vehicle } });
    },
    handleDelete(vehicle) {
      const modalDescription = `Are you sure you want to delete vehicle ${vehicle.reg_no}, an Email will be sent to owner to notify them of they deletion`;
      const modalText = "Press confirm to continue with deletion";
      this.$store.dispatch("Dashboard/setModalDescription", modalDescription);
      this.$store.dispatch("Dashboard/setModalText", modalText);
      this.deleteVehicle = vehicle;
      this.$store.dispatch("Dashboard/showWarningModal");
    },
    handleConfirm() {
      this.$store.dispatch("Dashboard/deleteVehicle", this.deleteVehicle);
    },

    handleCancel() {
      this.$store.dispatch("Dashboard/hideWarningModal");
    },

    handleUpdate(vehicle) {
      this.$store.dispatch("Dashboard/setUpdateVehicle", vehicle);
      this.$store.dispatch("Dashboard/showVehicleUpdateModal");
    }
  }
};
</script>

<style>
.theme--light.search > .v-input__control > .v-input__slot {
  background: white !important;
  border: 1px solid lightgray !important;
}

.v-table.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 3.2rem;
}
</style>
